module.exports = __webpack_public_path__ + "static/img/motiverse_logo-typo.201ecda7.svg";